module.exports = __webpack_public_path__ + "img/cu.3e6555d1.svg";